// extracted by mini-css-extract-plugin
export default {"active":"Register_active__lR4DW","inactive":"Register_inactive__+jnsl"};